<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="content p-24" fxLayout="column" fxLayoutAlign="start">
    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="!isAtRootLevel" class="mb-48">
        <button mat-icon-button (click)="goBack()" class="mr-16">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <h2 class="my-0">{{ currentModule.name }}</h2>
    </div>

    <div *ngIf="programStructureWithProgramParticipant && isDataFetched; else shimmer">
        <div *ngIf="programItemService.programStructureWithProgramParticipantSubject$ | async; let programStructureWithProgramParticipant">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="8px" class="analytics-container">
                <div class="analytic-container bg-zinc-50 p-16 mb-16 w-100-p" fxLayout="column" fxLayoutAlign="space-between">
                    <span class="analytics-title mb-16"> {{ 'GENERAL.LABEL.PARTICIPANT_PROGRESS' | translate }}</span>
                    <div *ngIf="programStructureWithProgramParticipant.programParticipant.moduleUserProgress?.status === ModuleUserProgressStatus.InProgress; else statusLabel">
                        <mat-progress-bar
                            attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                            class="mb-4"
                            mode="determinate"
                            [value]="programStructureWithProgramParticipant.programParticipant.moduleUserProgress?.programProgress"
                        >
                        </mat-progress-bar>
                        <span class="analytics-value">
                            {{ programStructureWithProgramParticipant.programParticipant.moduleUserProgress?.coursesCompleted }}/{{
                                programStructureWithProgramParticipant.programParticipant.moduleUserProgress?.coursesBooked
                            }}
                            &nbsp;
                            <span>{{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.COURSES_COMPLETED' | translate }}</span>
                        </span>
                    </div>

                    <ng-template #statusLabel>
                        <span class="analytics-description">
                            {{
                                programStructureWithProgramParticipant.programParticipant.moduleUserProgress?.status
                                    | getStatus: moduleCompletitionStatus:'translationLabel'
                                    | translate
                            }}
                        </span>
                    </ng-template>
                </div>

                <div class="analytic-container bg-zinc-50 p-16 mb-16 w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxLayoutAlign="space-between" class="h-full">
                        <span class="analytics-title mb-8">{{ 'FINAL_GRADE.LABEL.GRADE' | translate }}</span>
                        <span class="analytics-description">{{
                            programStructureWithProgramParticipant.programFinalGrade.grade
                                ? (programStructureWithProgramParticipant.programFinalGrade.grade.description | translate)
                                : ('FINAL_GRADE.LABEL.NOT_GRADED' | translate)
                        }}</span>
                    </div>

                    <div *ngIf="programStructureWithProgramParticipant.programFinalGrade.grade">
                        <span
                            class="program-final-grade text pointer bg-white"
                            fxLayoutAlign="center center"
                            [style.color]="programStructureWithProgramParticipant.programFinalGrade.grade.passing ? '#464B54' : '#FF0000'"
                        >
                            {{ programStructureWithProgramParticipant.programFinalGrade.grade.numericValue }}
                            <div class="icon-tooltip-container">
                                <span>{{ 'FINAL_GRADE.LABEL.GRADE' | translate }}:</span>
                                <strong>
                                    <span>
                                        {{ programStructureWithProgramParticipant.programFinalGrade.grade.displayValue }}: ({{
                                            programStructureWithProgramParticipant.programFinalGrade.grade.numericValue
                                        }})
                                    </span>
                                </strong>
                            </div>
                        </span>
                    </div>
                </div>

                <div class="analytic-container bg-zinc-50 p-16 mb-16 w-100-p" fxLayout="column" fxLayoutAlign="space-between">
                    <span class="analytics-title mb-8"> {{ 'PROGRAM_CERTIFICATE.SINGULAR' | translate }}</span>

                    <div
                        fxLayout="row"
                        fxLayoutAlign="space-between"
                        *ngIf="programStructureWithProgramParticipant.programFinalGrade.certificate; else noCertificate"
                        (click)="certificateService.downloadFinalGradeCertificate(programStructureWithProgramParticipant.programFinalGrade.certificate)"
                    >
                        <div class="certificate-container pointer" fxLayout="row" fxLayoutAlign="space-between center">
                            <span class="circle blue">
                                <mat-icon svgIcon="certificate"></mat-icon>
                            </span>

                            <span class="analytics-description certificate-name ml-8">{{ programStructureWithProgramParticipant.programFinalGrade.certificate.name }}</span>
                        </div>
                    </div>
                    <ng-template #noCertificate>
                        <span class="analytics-description">{{ 'CERTIFICATE.LABEL.NOT_ASSIGNED' | translate }}</span>
                    </ng-template>
                </div>

                <div
                    class="analytic-container bg-zinc-50 certificates p-16 w-100-p"
                    fxLayout="column"
                    fxLayoutAlign="space-between"
                    *ngFor="let certificateOfAttendance of programStructureWithProgramParticipant.programParticipant.certificates"
                >
                    <span class="analytics-title mb-8"> {{ 'CERTIFICATE.LABEL.CERTIFICATE_OF_ATTENDANCE' | translate }}</span>

                    <div fxLayout="row" fxLayoutAlign="space-between" (click)="certificateService.downloadFinalGradeCertificate(certificateOfAttendance)">
                        <div class="certificate-container pointer" fxLayout="row" fxLayoutAlign="space-between center">
                            <span class="circle blue">
                                <mat-icon svgIcon="certificate"></mat-icon>
                            </span>

                            <span class="analytics-description certificate-name ml-8">{{ certificateOfAttendance.name }}</span>
                        </div>
                    </div>
                </div>

                <div class="analytic-container bg-zinc-50 p-16 mb-16 w-100-p" fxLayout="column" fxLayoutAlign="space-between" *ngIf="isModuleFeatureAttendanceActive">
                    <span class="analytics-title mb-16"> {{ 'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE' | translate }}</span>
                    <div *ngIf="currentModule.kind !== ModuleKind.ProgramTemplate; else programTemplate">
                        <div *ngIf="programStructureWithProgramParticipant.programParticipant.attendance">
                            <mat-progress-bar
                                attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                class="mb-4"
                                mode="determinate"
                                [value]="programStructureWithProgramParticipant.programParticipant.attendance.percentage"
                            >
                            </mat-progress-bar>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <span class="analytics-value">
                                    {{
                                        'EVENT.ATTENDANCE.PROGRAM_ATTENDANCE'
                                            | translate
                                                : {
                                                      total: programStructureWithProgramParticipant.programParticipant.attendance.total
                                                  }
                                    }}
                                </span>
                                <span class="analytics-value">{{ programStructureWithProgramParticipant.programParticipant.attendance.percentage }}%</span>
                            </div>
                        </div>
                    </div>
                    <ng-template #programTemplate> - </ng-template>
                </div>
            </div>
        </div>

        <div class="course-offerings-category-container mt-24">
            <div class="course-offerings-container">
                <div *ngFor="let programItemWithGroup of programStructure; first as isFirst; last as isLast" class="mb-16">
                    <div *ngIf="programItemWithGroup.group" fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <h3 class="text-gray-600 font-medium mt-0 mb-16">
                                {{ programItemWithGroup.group.name | translate }}
                            </h3>
                        </div>
                    </div>
                    <div
                        style="margin-right: -8px"
                        class="course-offering-cards-container"
                        fxLayout="row wrap"
                        fxLayoutAlign="start"
                        fxLayoutGap="8px"
                        *ngIf="programItemWithGroup.programItems.length"
                    >
                        <div
                            fxLayout="row"
                            fxFlex.gt-sm="1 0 calc(25% - 8px)"
                            class="course-offering-card-container w-100-p"
                            *ngFor="let programItem of programItemWithGroup.programItems"
                        >
                            <app-my-course-card
                                fxLayout="row"
                                class="w-100-p"
                                [team]="team"
                                [programItem]="programItem"
                                [unsplashViewsBaseUrl]="unsplashViewsBaseUrl"
                                [module]="currentModule"
                                [bgColor]="'bg-zinc-50'"
                                [user]="user"
                                [participantId]="participantId"
                                [isTeamProgramMemberDialog]="true"
                                [isCurrentUserTenantAdmin]="isCurrentUserTenantAdmin"
                            ></app-my-course-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap="8px grid">
            <div class="shimmer w-100-p mb-24">
                <div fxLayout="row wrap" fxLayoutGap="8px">
                    <div
                        *ngFor="let _ of [1, 2, 3]; let i = index"
                        class="shimmer-card module animate !h-24"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(33.33%-8px)"
                    ></div>
                </div>
            </div>
            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-40 mt-28 mb-16 animate"></div>
                <div fxLayout="row wrap" fxLayoutGap="8px">
                    <div
                        *ngFor="let _ of [1, 2, 3, 4]; let i = index"
                        class="shimmer-card module animate mb-8 !h-60"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(25%-8px)"
                    ></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
